import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ImageZoom = ({ src, images = [], alt, className }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Construct a flat gallery array – fallback to the single src when no extra images are provided
  const gallery = images && images.length ? images : [{ asset: { url: src }, alt }];
  const currentImage = gallery[currentIndex];

  return (
    <div className={`${className || ''}`}>
      {/* Main Image */}
      <div className="overflow-hidden rounded-lg">
      <motion.img
          src={currentImage.asset?.url || currentImage.url || src}
          alt={currentImage.alt || alt}
        className="w-full h-full object-cover transition-all duration-500"
        whileHover={{ scale: 1.1 }}
          transition={{ type: 'tween', ease: 'easeOut' }}
        />
      </div>

      {/* Thumbnails */}
      {gallery.length > 1 && (
        <div className="flex gap-2 mt-4 overflow-x-auto">
          {gallery.map((img, idx) => (
            <motion.img
              key={img._key || idx}
              src={img.asset?.url || img.url}
              alt={img.alt || alt}
              className={`w-16 h-16 object-cover cursor-pointer rounded-md border ${idx === currentIndex ? 'border-akasha-brown' : 'border-transparent'}`}
              onClick={() => setCurrentIndex(idx)}
              whileHover={{ scale: 1.05 }}
      />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageZoom;
